export default "__VITE_ASSET__2NtUlm7I__"